
/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CompanyChoiceRequest,
  CompanyDetailsRequest,
  EmailValidationRequest,
  PhoneNumberRequest,
  QuestionAnswersRequest,
  SignupInitializationRequestForInvitation,
  SignupInitializationRequestWithAuthenticationDetails,
  SignupStateResponse,
  UserDetailsRequest,
  ValidationError,
} from '../models';
import {
    CompanyChoiceRequestFromJSON,
    CompanyChoiceRequestToJSON,
    CompanyDetailsRequestFromJSON,
    CompanyDetailsRequestToJSON,
    EmailValidationRequestFromJSON,
    EmailValidationRequestToJSON,
    PhoneNumberRequestFromJSON,
    PhoneNumberRequestToJSON,
    QuestionAnswersRequestFromJSON,
    QuestionAnswersRequestToJSON,
    SignupInitializationRequestForInvitationFromJSON,
    SignupInitializationRequestForInvitationToJSON,
    SignupInitializationRequestWithAuthenticationDetailsFromJSON,
    SignupInitializationRequestWithAuthenticationDetailsToJSON,
    SignupStateResponseFromJSON,
    SignupStateResponseToJSON,
    UserDetailsRequestFromJSON,
    UserDetailsRequestToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface AnswerQuestionUserQualificationRequest {
    questionAnswersRequest: QuestionAnswersRequest;
}

export interface ChooseCompanyToJoinRequest {
    companyChoiceRequest: CompanyChoiceRequest;
}

export interface InitSignupForInvitationRequest {
    signupInitializationRequestForInvitation: SignupInitializationRequestForInvitation;
}

export interface InitSignupWithAuthenticationDetailsRequest {
    signupInitializationRequestWithAuthenticationDetails: SignupInitializationRequestWithAuthenticationDetails;
}

export interface SaveCompanyDetailsRequest {
    companyDetailsRequest: CompanyDetailsRequest;
}

export interface SavePhoneNumberRequest {
    phoneNumberRequest: PhoneNumberRequest;
}

export interface SaveUserDetailsRequest {
    userDetailsRequest: UserDetailsRequest;
}

export interface ValidateEmailAddressRequest {
    emailValidationRequest: EmailValidationRequest;
}

/**
 * 
 */
export class ClientSignupApi extends runtime.BaseAPI {

    /**
     * Acknowledge the fact that the user want to continue the signup with a public email.
          */
    async acknowledgePublicEmailWarningPageRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/acknowledge-public-email-warning`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Acknowledge the fact that the user want to continue the signup with a public email.
          */
    async acknowledgePublicEmailWarningPage(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.acknowledgePublicEmailWarningPageRaw(initOverrides);
        return response._data;
    }

    /**
     * Save the answers of a user qualification question
          */
    async answerQuestionUserQualificationRaw(requestParameters: AnswerQuestionUserQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['questionAnswersRequest'] == null) {
            throw new runtime.RequiredError(
                'questionAnswersRequest',
                'Required parameter "questionAnswersRequest" was null or undefined when calling answerQuestionUserQualification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/signup-client/api/user-qualification/answer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestionAnswersRequestToJSON(requestParameters['questionAnswersRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Save the answers of a user qualification question
          */
    async answerQuestionUserQualification(requestParameters: AnswerQuestionUserQualificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.answerQuestionUserQualificationRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel client signup if one is in progress
          */
    async cancelSignupRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/cancellation-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Cancel client signup if one is in progress
          */
    async cancelSignup(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.cancelSignupRaw(initOverrides);
        return response._data;
    }

    /**
     * Choose the company to join within the organization that has been detected from the user email domain.
          */
    async chooseCompanyToJoinRaw(requestParameters: ChooseCompanyToJoinRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['companyChoiceRequest'] == null) {
            throw new runtime.RequiredError(
                'companyChoiceRequest',
                'Required parameter "companyChoiceRequest" was null or undefined when calling chooseCompanyToJoin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/company-choice`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyChoiceRequestToJSON(requestParameters['companyChoiceRequest']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Choose the company to join within the organization that has been detected from the user email domain.
          */
    async chooseCompanyToJoin(requestParameters: ChooseCompanyToJoinRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.chooseCompanyToJoinRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the current state of the client signup
          */
    async getStateRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get the current state of the client signup
          */
    async getState(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.getStateRaw(initOverrides);
        return response._data;
    }

    /**
     * Initialize a signup with an invitation (direct invitation, company invitation or organization invitation)
          */
    async initSignupForInvitationRaw(requestParameters: InitSignupForInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['signupInitializationRequestForInvitation'] == null) {
            throw new runtime.RequiredError(
                'signupInitializationRequestForInvitation',
                'Required parameter "signupInitializationRequestForInvitation" was null or undefined when calling initSignupForInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/signup-request-for-invitation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignupInitializationRequestForInvitationToJSON(requestParameters['signupInitializationRequestForInvitation']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Initialize a signup with an invitation (direct invitation, company invitation or organization invitation)
          */
    async initSignupForInvitation(requestParameters: InitSignupForInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.initSignupForInvitationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Initialize a signup with details to use to authenticate the user
          */
    async initSignupWithAuthenticationDetailsRaw(requestParameters: InitSignupWithAuthenticationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['signupInitializationRequestWithAuthenticationDetails'] == null) {
            throw new runtime.RequiredError(
                'signupInitializationRequestWithAuthenticationDetails',
                'Required parameter "signupInitializationRequestWithAuthenticationDetails" was null or undefined when calling initSignupWithAuthenticationDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/signup-request-with-authentication-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SignupInitializationRequestWithAuthenticationDetailsToJSON(requestParameters['signupInitializationRequestWithAuthenticationDetails']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Initialize a signup with details to use to authenticate the user
          */
    async initSignupWithAuthenticationDetails(requestParameters: InitSignupWithAuthenticationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.initSignupWithAuthenticationDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Request a new code to validate the email address
          */
    async requestNewValidationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/signup-client/api/validation-code-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Request a new code to validate the email address
          */
    async requestNewValidationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.requestNewValidationCodeRaw(initOverrides);
    }

    /**
     * Save the company details
          */
    async saveCompanyDetailsRaw(requestParameters: SaveCompanyDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['companyDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'companyDetailsRequest',
                'Required parameter "companyDetailsRequest" was null or undefined when calling saveCompanyDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/company-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyDetailsRequestToJSON(requestParameters['companyDetailsRequest']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Save the company details
          */
    async saveCompanyDetails(requestParameters: SaveCompanyDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.saveCompanyDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Save the phone number of a user. This should be called only if phone number is mandatory and not already provided
          */
    async savePhoneNumberRaw(requestParameters: SavePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['phoneNumberRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneNumberRequest',
                'Required parameter "phoneNumberRequest" was null or undefined when calling savePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/phone-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneNumberRequestToJSON(requestParameters['phoneNumberRequest']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Save the phone number of a user. This should be called only if phone number is mandatory and not already provided
          */
    async savePhoneNumber(requestParameters: SavePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.savePhoneNumberRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Save the user details
          */
    async saveUserDetailsRaw(requestParameters: SaveUserDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['userDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'userDetailsRequest',
                'Required parameter "userDetailsRequest" was null or undefined when calling saveUserDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/user-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserDetailsRequestToJSON(requestParameters['userDetailsRequest']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Save the user details
          */
    async saveUserDetails(requestParameters: SaveUserDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.saveUserDetailsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Save the user qualification
          */
    async saveUserQualificationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/user-qualification`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Save the user qualification
          */
    async saveUserQualification(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.saveUserQualificationRaw(initOverrides);
        return response._data;
    }

    /**
     * Start a new workflow in order to change user email.
          */
    async userAskToChangeEmailRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/change-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Start a new workflow in order to change user email.
          */
    async userAskToChangeEmail(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.userAskToChangeEmailRaw(initOverrides);
        return response._data;
    }

    /**
     * Validate the email address with code received by email
          */
    async validateEmailAddressRaw(requestParameters: ValidateEmailAddressRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SignupStateResponse>> {
        if (requestParameters['emailValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'emailValidationRequest',
                'Required parameter "emailValidationRequest" was null or undefined when calling validateEmailAddress().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SignupStateResponse>({
            path: `/signup-client/api/email-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailValidationRequestToJSON(requestParameters['emailValidationRequest']),
        }, initOverrides);

        if (response._data) { response._data=SignupStateResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Validate the email address with code received by email
          */
    async validateEmailAddress(requestParameters: ValidateEmailAddressRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SignupStateResponse> {
        const response = await this.validateEmailAddressRaw(requestParameters, initOverrides);
        return response._data;
    }

}
